import * as React from "react";

import { cn } from "@replohq/lattice/utils/cn";
import { DURATION, EASING } from "@replohq/lattice/utils/motion";
import { AnimatePresence, motion, useReducedMotion } from "motion/react";
import { useInterval } from "replo-utils/react/use-interval";

const agentLaunchClaims = [
  "Start from any URL, screenshot, or Figma file. Build an editable landing page.",
  "Create products, connect Stripe checkout, and send paid orders to Printful.",
  "Read Meta performance and turn the winning creative into a landing page.",
] as const;

const CLAIM_ROTATION_MS = 4_500;

export const AgentLaunchClaim: React.FC<{ className?: string }> = ({
  className,
}) => {
  const [claimIndex, setClaimIndex] = React.useState(0);
  const shouldReduceMotion = useReducedMotion();
  const claim = agentLaunchClaims[claimIndex] ?? agentLaunchClaims[0];

  useInterval(
    () => {
      setClaimIndex(
        (currentIndex) => (currentIndex + 1) % agentLaunchClaims.length,
      );
    },
    shouldReduceMotion ? null : CLAIM_ROTATION_MS,
  );

  return (
    <div
      className={cn("relative w-full overflow-hidden", className)}
      style={{ height: "2lh" }}
    >
      <span className="sr-only">{agentLaunchClaims.join(" ")}</span>
      <AnimatePresence mode="popLayout" initial={false}>
        <motion.p
          key={claim}
          aria-hidden
          className="absolute inset-0 m-0"
          initial={
            shouldReduceMotion ? { opacity: 0 } : { y: "100%", opacity: 0 }
          }
          animate={{ y: 0, opacity: 1 }}
          exit={
            shouldReduceMotion ? { opacity: 0 } : { y: "-100%", opacity: 0 }
          }
          transition={{ duration: DURATION.slow, ease: EASING.outQuint }}
        >
          {claim}
        </motion.p>
      </AnimatePresence>
    </div>
  );
};
